import { createApiSlice } from "@common";
import {
  CRUD_INTEGRATION_MCP,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addIntegrationMcp",
    method: "post",
    url: CRUD_INTEGRATION_MCP,
    stateKey: "message",
  },
  {
    name: "getIntegrationMcp",
    method: "get",
    url: CRUD_INTEGRATION_MCP,
    stateKey: "data",
  },
  {
    name: "updateIntegrationMcp",
    method: "put",
    url: CRUD_INTEGRATION_MCP,
    stateKey: "message",
  },
  {
    name: "deleteIntegrationMcp",
    method: "delete",
    url: CRUD_INTEGRATION_MCP,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "IntegrationMcp",
  apiConfig,
  customReducers,
);
const integrationMcpSlice = slice;
// Export the slice's reducer
export default integrationMcpSlice.reducer;


// Destructure and export thunks directly from thunksExports
export const {
  addIntegrationMcp,
  getIntegrationMcp,
  updateIntegrationMcp,
  deleteIntegrationMcp,
} = thunks;

// Destructure and export actions 
export const { rowSelect, } =
  actions;
